// src/FilterChip.tsx
import React, { FC } from 'react';
import CloseIcon from '@mui/icons-material/Close';

export interface FilterChipProps {
  label: string;
  onRemove: (value: string) => void;
  className?: string;
}

export const FilterChip: FC<FilterChipProps> = ({
  label,
  onRemove,
  className = '',
}) => {
  return (
    <button
      type="button"
      className={`base-calendar-filter-chip ${className}`}
      onClick={() => onRemove(label)}
    >
    <CloseIcon
      fontSize="small"
      className="base-calendar-filter-chip-remove"
    />
      {' '}{label}
    </button>
  );
};
